export const cycleUserDefectCountDefaultReportColumns = [
  {
    Header: 'Created By',
    accessor: 'createdBy',
    textAlign: 'left'
  },
  {
    Header: 'Project Name',
    accessor: 'projectName',
    textAlign: 'left'
  },
  {
    Header: 'Test Cycle Code',
    accessor: 'cycleCode',
    textAlign: 'left'
  },
  {
    Header: 'Test Cycle Name',
    accessor: 'cycleName',
    textAlign: 'left'
  },
  {
    Header: 'Defect Status',
    accessor: 'status',
    textAlign: 'left'
  },
  {
    Header: 'Defect Count',
    accessor: 'totalValue',
    textAlign: 'left'
  }
];

export const suiteTestCaseExecutionCountDefaultReportColumns = [
  {
    Header: 'Test Suite Code',
    accessor: 'testSuiteCode',
    textAlign: 'left'
  },
  {
    Header: 'Test Suite Name',
    accessor: 'testSuiteName',
    textAlign: 'left'
  },
  {
    Header: 'Test Case Code',
    accessor: 'testCaseCode',
    textAlign: 'left'
  },
  {
    Header: 'Summary',
    accessor: 'summary',
    textAlign: 'left'
  },
  {
    Header: 'Tester',
    accessor: 'tester',
    textAlign: 'left'
  },
  {
    Header: 'Execution Count',
    accessor: 'totalValue',
    textAlign: 'left'
  }
];
